import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authService } from "../../services/authService";
import { toast } from "../../services/toastService";
import Loading from "../../components/Loading";
import { AuthContext } from "../../contexts/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const initialForm = {
    userName: "",
    password: ""
  };
  const [form, setForm] = useState(initialForm);
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkAuthenticationAsync();
  }, []);

  const checkAuthenticationAsync = async () => {
    try {
      setLoading(true);
      // Fixed: Added missing await
      const response = await authService.checkAuthenticationAsync();
      if (response.isSuccess) {
        navigate("/equipment-certificates");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const { login } = useContext(AuthContext);

const handleLogin = async (e) => {
  e.preventDefault();

  try {
    setBtnLoading(true);

    const response = await authService.loginAsync(form);

    if (!response || !response.isSuccess) {
      toast.error(
        response?.errors?.[0] || "Invalid credentials"
      );
      return;
    }

    login(response.value);

    navigate("/equipment-certificates");

  } catch (error) {
    console.log(error);

    toast.error(
      error?.response?.data?.errors?.[0] ||
      "An error occurred while logging in"
    );
  } finally {
    setBtnLoading(false);
  }
};

  if (loading) return <Loading />;

  return (
    <section className="section-auth">
      <div className="auth-card">
        <div className="auth-card-body">
          <span className="auth-card-title">Sign in to start your session</span>
          {/* Handled submission directly on the form */}
          <form onSubmit={handleLogin}>
            <div className="form-group input-icon">
              <input
                type="text"
                className="form-control"
                placeholder="Email or username"
                value={form.userName}
                onChange={(e) => setForm({ ...form, userName: e.target.value })}
                required
              />
              <i className="fas fa-envelope" />
            </div>
            <div className="form-group input-icon">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
              <i className="fas fa-lock" />
            </div>
            <div className="flex-space-between">
              <Link to="/register" className="invisible">Register a new membership</Link>
              
              {/* Fixed: changed to type="submit" and corrected onclick to onClick */}
              {btnLoading ? (
                <button type="button" className="my-button" disabled>
                  Loading...
                </button>
              ) : (
                <button type="submit" className="my-button">
                  Sign In
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;